<template>
    <div class="container">
        <div v-if="error" class="alert alert-danger" role="alert">
            Podane hasła różnią się !
        </div>
        <div class="form-group">
            <label for="">Podaj nowe hasło !</label>
            <input class="form-control" type="password" v-model="firstPassword">
        </div>
        <div class="form-group">
            <label for="">Ponownie podaj nowe hasło!</label>
            <input class="form-control" type="password" v-model="secondPassword">
        </div>
        <button @click="submit" type="submit" class="btn btn-primary">Wyślij</button>
    </div>
</template>
<script>
import { setInterval } from 'timers';
export default {
    data() {
        return{
            params: {},
            firstPassword:'',
            secondPassword:'',
            error: false
        }
    },
    methods: {
        submit() {
            if(this.firstPassword == this.secondPassword) {
                this.$store.dispatch('user/changepassword', {uid:this.params.uid, hash: this.params.hash,password: this.secondPassword})
                this.$router.push({name:'mainPage'});
            } else {
                this.error = true;
                setInterval(()=>{
                    this.error = false;
                },5000)
            }
        }
    },
    beforeMount() {
        this.params = this.$route.query;
    }
}
</script>



// WEBPACK FOOTER //
// src/components/template/ClearPass.vue